import React, { Component } from "react";
import Card from "@material-ui/core/Card";
import CardHeader from "@material-ui/core/CardHeader";
import CardContent from "@material-ui/core/CardContent";
import TextField from "@material-ui/core/TextField";
import InputAdornment from "@material-ui/core/InputAdornment";
import {
    MuiPickersUtilsProvider,
    KeyboardDatePicker
} from "@material-ui/pickers";
import DateFnsUtils from "@date-io/date-fns";
import NumberFormat from 'react-number-format';

export class ProjectFinancialData extends Component {
    render() {
        const {
            onChange,
            onChangeDate,
            totalBudget,
            euContribution,
            nationalCoFinancing,
            otherCoFinancing,
            mainComponentBudget,
            totalFundsDisbursed,
            lastDateOfPayment,
            userType,
        } = this.props;
        return (
            <Card>
                <CardHeader
                    title="Project Financial Data"
                    className="romis-card-header"
                />
                <CardContent>
                    <NumberFormat
                        customInput={TextField}
                        thousandSeparator=","
                        decimalSeparator="."
                        label="Total Budget :"
                        placeholder="Total Budget"
                        fullWidth
                        margin="normal"
                        InputLabelProps={{
                            shrink: true
                        }}
                        InputProps={{
                            startAdornment: <InputAdornment position="start">€</InputAdornment>
                        }}
                        onChange={onChange}
                        value={totalBudget}
                        name="totalBudget"
                        disabled={userType !== 2 ? true : false}
                    />

                    {
                        // <TextField
                        //    label="Total Budget :"
                        //    placeholder="Total Budget"
                        //    fullWidth
                        //    margin="normal"
                        //    InputLabelProps={{
                        //        shrink: true
                        //    }}
                        //    InputProps={{
                        //        endAdornment: <InputAdornment position="end">€</InputAdornment>
                        //    }}
                        //    onChange={onChange}
                        //    value={totalBudget}
                        //    name="totalBudget"
                        // />
                    }

                    {
                        //<TextField
                    }

                    <NumberFormat
                        customInput={TextField}
                        thousandSeparator=","
                        decimalSeparator="."
                        label="EU Contribution :"
                        placeholder="EU Contribution"
                        fullWidth
                        margin="normal"
                        InputLabelProps={{
                            shrink: true
                        }}
                        InputProps={{
                            startAdornment: <InputAdornment position="start">€</InputAdornment>
                        }}
                        onChange={onChange}
                        value={euContribution}
                        name="euContribution"
                        disabled={userType !== 2 ? true : false}
                    />

                    {
                        //<TextField
                    }

                    <NumberFormat
                        customInput={TextField}
                        thousandSeparator=","
                        decimalSeparator="."
                        label="National Co-Financing :"
                        placeholder="National Co-Financing"
                        fullWidth
                        margin="normal"
                        InputLabelProps={{
                            shrink: true
                        }}
                        InputProps={{
                            startAdornment: <InputAdornment position="start">€</InputAdornment>
                        }}
                        onChange={onChange}
                        value={nationalCoFinancing}
                        name="nationalCoFinancing"
                        disabled={userType !== 2 ? true : false}
                    />

                    {
                        //<TextField
                    }

                    <NumberFormat
                        customInput={TextField}
                        thousandSeparator=","
                        decimalSeparator="."
                        label="Other Co-Financing :"
                        placeholder="Other Co-Financing"
                        fullWidth
                        margin="normal"
                        InputLabelProps={{
                            shrink: true
                        }}
                        InputProps={{
                            startAdornment: <InputAdornment position="start">€</InputAdornment>
                        }}
                        onChange={onChange}
                        value={otherCoFinancing}
                        name="otherCoFinancing"
                        disabled={userType !== 2 ? true : false}
                    />

                    {
                        //<TextField
                    }

                    <NumberFormat
                        customInput={TextField}
                        thousandSeparator=","
                        decimalSeparator="."
                        label="Main Component Budget :"
                        placeholder="Main Component Budget"
                        fullWidth
                        margin="normal"
                        InputLabelProps={{
                            shrink: true
                        }}
                        InputProps={{
                            startAdornment: <InputAdornment position="start">€</InputAdornment>
                        }}
                        onChange={onChange}
                        value={mainComponentBudget}
                        name="mainComponentBudget"
                        disabled={userType !== 2 ? true : false}
                    />

                    {
                        //<TextField
                    }

                    <NumberFormat
                        customInput={TextField}
                        thousandSeparator=","
                        decimalSeparator="."
                        label="Total Funds Disbursed :"
                        placeholder="Total Funds Disbursed"
                        fullWidth
                        margin="normal"
                        InputLabelProps={{
                            shrink: true
                        }}
                        InputProps={{
                            startAdornment: <InputAdornment position="start">€</InputAdornment>
                        }}
                        onChange={onChange}
                        value={totalFundsDisbursed}
                        name="totalFundsDisbursed"
                        disabled={userType !== 2 ? true : false}
                    />

                    {
                        //<MuiPickersUtilsProvider utils={DateFnsUtils}>
                        //    <KeyboardDatePicker

                        //        margin="normal"
                        //        variant="inline"
                        //        label="Last Date Of Payment :"
                        //        format="dd/MM/yyyy"
                        //        fullWidth
                        //        onChange={value => {
                        //            onChangeDate("lastDateOfPayment", value);
                        //        }}
                        //        //value={lastDateOfPayment === "" ? new Date() : lastDateOfPayment}
                        //        value={lastDateOfPayment}
                        //        name="lastDateOfPayment"
                        //        InputLabelProps={{
                        //            shrink: true
                        //        }}
                        //        autoOk
                        //    />
                        //</MuiPickersUtilsProvider>
                    }

                </CardContent>
            </Card>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/ProjectFinancialData.js